module.exports = __webpack_public_path__ + "img/customer_colopl.c67de466.png";